<template>
  <div class="mb-5">
    <button @click="changeTypeToShowRoute('all')" :style="{ background: 'none', color: getPrimaryColor() }" class="d-flex align-items-center font14 mb-4" v-if="typeToShow !== 'all'">
      <font-awesome-icon :icon="['far', 'arrow-left']" class="font20 mr-2" />
      Back
    </button>

    <h1 class="gray900 fw700 font32 mb-4">{{ type }} Reviews</h1>

    <div v-if="loading" class="d-flex justify-content-center my-3">
      <div>
        <div class="spinner-border position-absolute spinner-class"></div>
      </div>
      <div :style="{ 'margin-left': '-14px', 'margin-top': '40px' }">Loading...</div>
    </div>

    <div v-else-if="!loading && !reviews.length" class="p-4 bg-gray100 br8 d-flex flex-column align-items-center mb-5">
      <template v-if="viewUser">
        <p class="mb-0 gray900 font20 fw700">This {{ viewUser.role }} has no {{ type }} reviews yet.</p>
        <template v-if="canReview(viewUser.role)">
          <p class="mb-0 font14 gray700 my-2">Be the first to review this {{ viewUser.role }}.</p>
          <button class="p1224 text-white br6 fw700 font14" :style="{ background: getPrimaryColor() }" @click="handleReviewClick">Review</button>
        </template>
      </template>
      <p v-else class="mb-0 gray900 font20 fw700">You have no reviews yet</p>
    </div>

    <template v-else>
      <template v-if="type == 'In Person Visit' || !type">
        <ReviewCardCore v-for="review in reviews" :reviewData="review" :key="review.id" :ownerView="isOwnerView" :getReviewsFromCore="getReviewsFromCore" />
      </template>
      <template v-else>
        <IndividualReviewCard v-for="review in reviews" :reviewData="review" :key="review" :showAllreviewsButton="false" />
      </template>
    </template>

    <button
      @click="changeTypeToShowRoute(type)"
      :style="{ width: '100%', background: getPrimary50Color(), color: getPrimaryColor(), padding: '12px' }"
      class="br8 flex-center-center fw700 font14"
      v-if="typeToShow === 'all' && totalReviews > 3 && type"
    >
      View {{ totalReviews - 3 }} more {{ type }} Reviews
      <font-awesome-icon :icon="['far', 'arrow-right']" class="font20 ml-2" />
    </button>

    <a-pagination
      v-if="typeToShow !== 'all' || !type"
      v-model="currentPage"
      class="dovemed-custom-pagination d-flex justify-content-center"
      show-less-items
      :pageSize="10"
      :total="totalReviews"
      @change="handleChangePage"
    />

    <recommend-doctor ref="doctorRev" />
    <recommend-others ref="othersRev" />
  </div>
</template>

<script>
import { RepositoryFactory } from "../../../repositories/RepositoryFactory"
import { mapGetters } from "vuex"
import IndividualReviewCard from "./ReviewTabCard.vue"
import ReviewCardCore from "./ReviewCardCore.vue"
import RecommendOthers from "../../Modals/RecommendOthers.vue"
import RecommendDoctor from "../../Modals/RecommendDoctor.vue"

const ReviewsRepository = RepositoryFactory.get("reviews")

export default {
  components: { ReviewCardCore, IndividualReviewCard, RecommendOthers, RecommendDoctor },
  name: "ProfileReceivedReviewsSection",
  props: { type: String, typeToShow: String, changeTypeToShow: Function },
  data() {
    return { loading: false, currentPage: 1, reviews: [], totalReviews: 0, type: "", isOwnerView: false }
  },
  created() {
    console.warn("ProfileReceivedReviewsSection.vue is created")
    console.log("viewUser", this.viewUser)
  },
  mounted() {},
  computed: {
    ...mapGetters({ toggleReview: "User/toggleReview" }),
  },
  watch: {
    toggleReview: {
      handler(v) {
        console.warn("ProfileReceivedReviewsSection -> watching toggleReview")
        this.getReviews()
      },
      immediate: true,
    },
    typeToShow: {
      handler(v, o) {
        this.getReviews()
      },
      immediate: true,
    },
  },
  methods: {
    handleReviewClick() {
      if (!this.viewUser) {
        return
      }
      switch (this.viewUser.role) {
        case "patient":
        case "caregiver":
        case "advocate":
        case "nfp":
        case "nfp_administrator":
        case "business":
        case "business_administrator":
          this.$notification.error({ message: "Denied", description: `${this.authUser.user.role} cannot review a ${this.viewUser.role}` })
          break
        case "doctor":
        case "physician":
        case "ahp":
        case "ahcp":
        case "hcp":
        case "ohcp":
        case "amp":
        case "app":
        case "other":
          if (!["patient", "caregiver", "advocate"].includes(this.authUser.user.role)) {
            this.$notification.error({ message: "Denied", description: `${this.authUser.user.role} cannot review a ${this.viewUser.role}` })
            return
          }
          this.$refs.doctorRev.show({ ...this.viewUser, inPersonReview: this.viewUser.in_person_visit, onlineReview: this.viewUser.online_tele_medicine, myCirclesReview: this.viewUser.my_circle })
          break
        case "clinic":
        case "clinic_administrator":
        case "hospital":
        case "hospital_administrator":
          if (!["patient", "caregiver", "advocate"].includes(this.authUser.user.role)) {
            this.$notification.error({ message: "Denied", description: `${this.authUser.user.role} cannot review a ${this.viewUser.role}` })
            return
          }
          this.$refs.othersRev.show(this.viewUser)
          break
        default:
          this.$notification.error({ message: "Denied", description: `${this.authUser.user.role} cannot review a ${this.viewUser.role}` })
          break
      }
    },
    changeTypeToShowRoute(revType) {
      const typeOfProfileURL = `${this.$route.path.includes("/view/") ? `view/${this.viewUser.role}/${this.viewUser.id || this.viewUser.ext_ref_id}` : `${this.authUser.user.role}`}`
      switch (revType) {
        case "Telemedicine":
          this.$router.push({ path: `/${this.currentCircle.key_name}/profile/${typeOfProfileURL}/receivedreviews/online` })
          break
        case "In Person Visit":
          this.$router.push({ path: `/${this.currentCircle.key_name}/profile/${typeOfProfileURL}/receivedreviews/inperson` })
          break
        case "MyCircles":
          this.$router.push({ path: `/${this.currentCircle.key_name}/profile/${typeOfProfileURL}/receivedreviews/mycircles` })
          break
        default:
          this.$router.push({ path: `/${this.currentCircle.key_name}/profile/${typeOfProfileURL}/receivedreviews/all` })
      }
      this.changeTypeToShow()
    },
    getReviews() {
      this.reviews = []
      this.totalReviews = 0
      if (["MyCircles", "Telemedicine"].includes(this.type)) {
        this.fetchIndividualReviews()
      } else {
        this.getReviewsFromCore()
      }
    },
    handleChangePage(page) {
      this.currentPage = page
      this.getReviews()
    },
    fetchIndividualReviews() {
      this.loading = true
      ReviewsRepository.getIndividualReviews(
        this.currentCircle.id,
        this.currentPage,
        this.typeToShow === "all" ? 3 : 10,
        this.$route.path.includes("/view/") ? this.viewUser.ext_ref_id || this.viewUser.id : this.authUser.user.ext_ref_id || this.authUser.user.id,
        this.type === "MyCircles" ? "MyCircles" : "Online",
        "Newest",
        this.api_role
      )
        .then(res => {
          if (res.data.message === "found") {
            this.reviews = res.data.data.data
            this.totalReviews = parseInt(res.data.data.paginator.total_count)
          }
          this.loading = false
          // document.body.scrollTop = 0
        })
        .catch(err => {
          this.loading = false
        })
    },

    getReviewsFromCore() {
      const role = this.$route.path.includes("/view/") ? this.viewUser.role : this.authUser.user.role
      const ext_id = this.$route.path.includes("/view/") ? this.viewUser.ext_ref_id || this.viewUser.id : this.authUser.user.ext_ref_id || this.authUser.user.id
      const headers = { Authorization: `Basic ${btoa("dovemed:dovemed-rules")}`, dtoken: this.authUser.user.dovemed_csrf_token || this.authUser.user.dovemed_session_token }
      this.loading = true
      this.$http
        .get(
          // `${process.env.SSO_BASE_URL}/api/v2/${this.getCoreReviewApiRole(role)}/${ext_id}/review/?page=${this.currentPage}&page_size=${
          `${process.env.SSO_BASE_URL}/api/v2/review/${this.getCoreReviewApiRole(role)}/${ext_id}/review/?page=${this.currentPage}&page_size=${
            this.typeToShow === "all" && this.type ? 3 : 10
          }&ordering=-published`,
          { headers }
        )
        .then(res => {
          this.loading = false
          this.reviews = res.data.results
          this.totalReviews = res.data.count || 0
          // document.body.scrollTop = 0
        })
        .catch(e => {
          this.loading = false
          console.log("error: ", e)
          console.log(e.message)
          UserRepository.recordLogout()
          this.$store.dispatch("Auth/logout").then(() => {
            location.reload()
          })
        })
    },
  },
}
</script>

<style lang="scss" scoped>
button {
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/home/reviews/ProfileReceivedReviewsSection.vue